import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useApp } from "../context/AppContext";
import { isMainHost } from "../lib/hosts";
import { PIXEL_ID, getConsent, setConsent, loadMetaPixel, pageView, track, isMarketingPath } from "../lib/metaPixel";

const T = {
  en: { text: "We use cookies for analytics and Meta ads measurement. No learning-platform data is shared.", more: "Learn more", accept: "Accept", decline: "Decline" },
  ar: { text: "نستخدم ملفات الارتباط للتحليلات وقياس إعلانات Meta. لا تُشارَك أي بيانات من منصة التعلّم.", more: "اعرف المزيد", accept: "موافق", decline: "رفض" },
};

// Consent banner (always shown until a choice is made) + Meta Pixel PageView / ViewContent on route changes. LMS marketing site only.
export function MetaConsent() {
  const { lang } = useApp();
  const loc = useLocation();
  const [choice, setChoice] = useState(getConsent());
  const marketing = isMainHost() && isMarketingPath(loc.pathname);
  useEffect(() => { if (choice === "granted") loadMetaPixel(); }, [choice]);
  useEffect(() => {
    if (choice !== "granted" || !marketing) return;
    pageView();
    if (loc.pathname === "/pricing") track("ViewContent", { content_name: "pricing", content_category: "lms" });
    if (loc.pathname === "/security") track("ViewContent", { content_name: "security", content_category: "lms" });
  }, [loc.pathname, choice, marketing]);
  if (!PIXEL_ID || !marketing || choice) return null;
  const t = T[lang] || T.en;
  const pick = (v) => { setConsent(v); setChoice(v); };
  return (
    <div dir={lang === "ar" ? "rtl" : "ltr"} data-testid="consent-banner" className="fixed top-2 inset-x-2 sm:top-auto sm:bottom-4 sm:inset-x-auto sm:start-4 z-40 max-w-md rounded-xl sm:rounded-2xl border border-slate-200 bg-white/95 backdrop-blur shadow-2xl p-2.5 sm:p-4 flex gap-2 sm:gap-3 items-start">
      <span className="hidden sm:grid place-items-center w-9 h-9 rounded-xl bg-blue-50 text-[#0038EB] shrink-0"><Cookie size={18} /></span>
      <div className="text-xs sm:text-sm text-slate-700 leading-snug sm:leading-relaxed flex-1 flex flex-wrap items-center gap-x-2 gap-y-1.5">
        <span>{t.text} <Link to="/security#security-5" className="font-bold text-[#0038EB] hover:underline">{t.more}</Link></span>
        <div className="sm:mt-3 flex gap-1.5 sm:gap-2 ms-auto">
          <button type="button" data-testid="consent-accept" onClick={() => pick("granted")} className="h-8 sm:h-9 px-3 sm:px-4 rounded-full bg-[#0038EB] text-white text-xs sm:text-sm font-bold hover:bg-[#002bb8]">{t.accept}</button>
          <button type="button" data-testid="consent-decline" onClick={() => pick("denied")} className="h-8 sm:h-9 px-3 sm:px-4 rounded-full border border-slate-200 text-slate-700 text-xs sm:text-sm font-bold hover:bg-slate-50">{t.decline}</button>
        </div>
      </div>
    </div>
  );
}
